export interface ProductionProcessSupplier {
  id: string;
  productionProcessId: string;
  productionProcessDescription: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  default: boolean;
  defaultYesNo: string;
}
